import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledFormSection = styled.div`
  padding: 16px 20px 0;
  flex-shrink: 0;
`;

export const StyledCompanyInput = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 6px;
  padding: 8px 12px;
  background: ${colorsPalettes.bluegrey[100]};
  opacity: 0.85;
`;

export const StyledCompanyInputText = styled.input`
  flex: 1;
  border: none;
  outline: none;
  ${setFontVariant('body2', colorsPalettes.carbon[300])};
  background: transparent;
  cursor: default;
`;
